<template>
  <svg
    viewBox="0 0 620 390"
    class="fu-venue-svg"
    role="img"
    aria-label="Plano de demostración con escenario, pista general, mesas VIP y gradas"
  >
    <defs>
      <linearGradient id="fu-floor-grad" x1="0" y1="0" x2="1" y2="1">
        <stop stop-color="#191c22" />
        <stop offset="1" stop-color="#0b0d12" />
      </linearGradient>
      <linearGradient id="fu-stage-grad" x1="0" y1="0" x2="0" y2="1">
        <stop stop-color="#cfd8ea" />
        <stop offset="1" stop-color="#555e6d" />
      </linearGradient>
    </defs>
    <rect
      x="20"
      y="22"
      width="580"
      height="348"
      rx="14"
      fill="#030408"
      stroke="#39414e"
      stroke-width="3"
    />
    <rect
      x="20"
      y="12"
      width="580"
      height="348"
      rx="14"
      fill="url(#fu-floor-grad)"
      stroke="#687181"
      stroke-width="1"
    />
    <path d="M35 320H585M35 332H585M35 344H585" stroke="#272d37" />
    <rect
      x="164"
      y="38"
      width="300"
      height="83"
      rx="5"
      fill="#20252d"
      stroke="#788494"
    />
    <rect x="176" y="47" width="276" height="35" fill="url(#fu-stage-grad)" />
    <path
      d="M177 50L451 78M177 78L451 50M218 48V80M275 48V80M333 48V80M390 48V80"
      stroke="#f4f7ff"
      opacity=".5"
    />
    <rect
      x="271"
      y="88"
      width="82"
      height="20"
      rx="3"
      fill="#0a0b10"
      stroke="#a1adbd"
    />
    <circle cx="288" cy="98" r="6" fill="#657182" />
    <circle cx="335" cy="98" r="6" fill="#657182" />
    <rect x="190" y="90" width="30" height="20" fill="#101216" />
    <rect x="408" y="90" width="30" height="20" fill="#101216" />
    <text
      x="313"
      y="33"
      text-anchor="middle"
      fill="#cfd8ea"
      font-size="12"
      font-family="Space Grotesk, sans-serif"
    >
      ESCENARIO
    </text>
    <g data-map-zone="pista">
      <rect
        x="442"
        y="145"
        width="135"
        height="161"
        rx="6"
        fill="#aab7ca"
        opacity=".32"
        stroke="#dce4f0"
      />
      <path
        d="M454 159H565M454 176H565M454 193H565M454 210H565M454 227H565M454 244H565M454 261H565M454 278H565M454 295H565"
        stroke="#b4c0d2"
        opacity=".35"
      />
      <text
        x="509"
        y="224"
        text-anchor="middle"
        fill="#f4f7ff"
        font-size="15"
        font-family="Space Grotesk, sans-serif"
      >
        PISTA
      </text>
    </g>
    <g data-map-zone="mesas">
      <rect
        x="200"
        y="147"
        width="219"
        height="170"
        rx="7"
        fill="#b7c3d5"
        opacity=".1"
        stroke="#7a879a"
      />
      <g transform="translate(235 195)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(283 195)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(331 195)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(379 195)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(235 243)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(283 243)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(331 243)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(379 243)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(235 291)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(283 291)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(331 291)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <g transform="translate(379 291)">
        <circle r="13" fill="#212833" stroke="#cfd8ea" stroke-width="1.3" />
        <circle cx="-19" r="4" fill="#657286" />
        <circle cx="19" r="4" fill="#657286" />
        <circle cy="-19" r="4" fill="#657286" />
        <circle cy="19" r="4" fill="#657286" />
      </g>
      <text
        x="310"
        y="340"
        text-anchor="middle"
        fill="#cfd8ea"
        font-size="12"
        font-family="Space Grotesk, sans-serif"
      >
        MESAS VIP
      </text>
    </g>
    <g data-map-zone="gradas">
      <rect
        x="44"
        y="147"
        width="135"
        height="170"
        rx="5"
        fill="#a4b0c1"
        opacity=".12"
        stroke="#9daabd"
      />
      <rect x="57" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="68" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="79" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="90" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="101" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="112" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="123" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="134" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="145" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="156" y="178" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="57" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="68" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="79" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="90" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="101" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="112" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="123" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="134" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="145" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="156" y="201" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="57" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="68" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="79" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="90" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="101" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="112" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="123" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="134" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="145" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="156" y="224" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="57" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="68" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="79" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="90" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="101" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="112" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="123" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="134" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="145" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="156" y="247" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="57" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="68" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="79" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="90" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="101" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="112" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="123" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="134" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="145" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <rect x="156" y="270" width="7" height="12" rx="2" fill="#bbc7d9" />
      <text
        x="110"
        y="340"
        text-anchor="middle"
        fill="#cfd8ea"
        font-size="12"
        font-family="Space Grotesk, sans-serif"
      >
        GRADAS
      </text>
    </g>
    <rect
      x="48"
      y="52"
      width="75"
      height="32"
      rx="3"
      fill="#252c36"
      stroke="#8d9caf"
    />
    <path
      d="M57 56V75M67 56V75M77 56V75M87 56V75M97 56V75M107 56V75"
      stroke="#738195"
    />
    <text
      x="85"
      y="102"
      text-anchor="middle"
      fill="#a8b5c7"
      font-size="11"
      font-family="Space Grotesk, sans-serif"
    >
      BARRA
    </text>
    <path d="M475 353H554" stroke="#d3dce9" stroke-width="3" />
    <text
      x="516"
      y="379"
      text-anchor="middle"
      fill="#cfd8ea"
      font-size="11"
      font-family="Space Grotesk, sans-serif"
    >
      ACCESO ↑
    </text>
  </svg>
</template>
